import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database"; // For Realtime Database
import { getFirestore } from "firebase/firestore"; // For Firestore (if needed)
import { getStorage } from "firebase/storage"; // For Storage

const firebaseConfig = {
  apiKey: "AIzaSyALItLdNg4j0biXIvf_erA6XUSaRaoMlpM",
  authDomain: "schoolerp-6e6a1.firebaseapp.com",
  databaseURL: "https://schoolerp-6e6a1-default-rtdb.firebaseio.com", // Verified from your URL
  projectId: "schoolerp-6e6a1",
  storageBucket: "schoolerp-6e6a1.firebasestorage.app",// Corrected storage bucket
  messagingSenderId: "303406243703",
  appId: "1:303406243703:web:1c53270a42ed081c8e8b72"
};

const app = initializeApp(firebaseConfig);

// Initialize services
const db = getDatabase(app); // Realtime Database
const firestore = getFirestore(app); // Firestore (if you need both)
const storage = getStorage(app); // Storage

export { db, firestore, storage }; // Export all services you need